import { type ToastType, useMutationWithFeedback } from '@pesto/hooks';

import { toast } from '../components/Toaster';

type SonnerToastFn = typeof toast.success;

type ToastHistoryConfig = { title: string; description?: string } | false;

type ToastOptionsWithHistory = NonNullable<Parameters<SonnerToastFn>[1]> & { history?: ToastHistoryConfig };

const toastByType = {
  success: toast.success,
  error: toast.error,
  loading: toast.loading,
} satisfies Record<ToastType, SonnerToastFn>;

export const useMutationWithToast = (debug = false) => {
  return useMutationWithFeedback(
    {
      toast: (type, options) => {
        const { title, description, duration, action, history, ...toastOptions } = options;
        const toastHistory = history === undefined ? { title } : history;

        const optionsWithHistory: ToastOptionsWithHistory = {
          description,
          duration,
          action,
          ...toastOptions,
          history: toastHistory,
        };

        return toastByType[type](title, optionsWithHistory);
      },
      dismiss: (id) => toast.dismiss(id),
    },
    debug,
  );
};
